<svg id="Icons" aria-label="Icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  <title>General_89_T89</title>
  <path d="M14.523,7.039V5.246A4.4,4.4,0,0,0,9.992,1,4.4,4.4,0,0,0,5.461,5.246V7.039H3.341V19H16.659V7.039ZM7.128,5.246A2.736,2.736,0,0,1,9.992,2.667a2.736,2.736,0,0,1,2.865,2.579V7.039H7.128Zm7.864,12.087H10.826V13.105H9.159v4.228H5.008V8.706h9.984Z"/>
</svg>
